import React, { useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import {
  Table,
  Accordion,
} from "react-bootstrap";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS, formatStringKey } from "../../constant/_constant";
import moment from "moment";
import Lottie from "lottie-react";
import notfoundData from "../../assets/not_found.json";

function SKU_Vendor_POPUP({ show, setShow, vendorSku }) {
  const { postData: fetchVendor_HISTORY, data } = usePostRequest(
    API_ENDPOINTS.GET_VENDOR_REVISION_HISTORY,
  );

  const payloadData = {
    auto_id: vendorSku?.auto_id,
  };

  useEffect(() => {
    if (vendorSku?.auto_id) {
      fetchVendor_HISTORY(payloadData);
    }
  }, [vendorSku]);

  return (
    <Modal
      show={show}
      onHide={() => setShow({ show: false })}
      className="skusearch"
      dialogClassName="modal-90vw"
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Body>
        {/* Header */}
        <div className="text-center mb-4">
          <h4 className="mb-3 fw-bold">Changes History</h4>

          <div className="vendor-info-wrapper">
            <div className="vendor-info-item">
              <span className="vendor-info-label">Vendor Code</span>
              <span className="vendor-info-value">
                {vendorSku?.vendor_code || "N/A"}
              </span>
            </div>

            <div className="vendor-info-divider"></div>

            <div className="vendor-info-item">
              <span className="vendor-info-label">Company Name</span>
              <span className="vendor-info-value">
                {vendorSku?.display_name || "N/A"}
              </span>
            </div>
          </div>
        </div>

        <div className="text-center">
          {data && data.data && data.data.length > 0 ? (
            data.data.map((item, index) => (
              <div className="rfq_box_item" key={index}>
                <Accordion>
                  <Accordion.Item eventKey={String(index)}>
                    <Accordion.Header className="accordian_items">
                      {item.User.username}{" "}
                      {moment(item.updated_at).format("MM/DD/YYYY HH:mm")}
                    </Accordion.Header>

                    <Accordion.Body>
                      <div className="mail_wrapper p-0 border-0 mb-0">
                        <div className="table-responsive">
                          <Table bordered>
                            <thead>
                              <tr>
                                <th>Field</th>
                                <th>Old Value</th>
                                <th>New Value</th>
                              </tr>
                            </thead>

                            <tbody>
                              {item.changes_json.map((changeItem, idx) => {
                                let change = changeItem.changes;

                                return Object.keys(change).map(
                                  (key, idx2) => {
                                    const fieldChange = change[key];

                                    if (key === "other_cost") {
                                      return (
                                        <React.Fragment key={`${idx}-${idx2}`}>
                                          {fieldChange.added &&
                                            fieldChange.added.length > 0 &&
                                            fieldChange.added.map(
                                              (addedItem, addedIdx) => (
                                                <tr
                                                  key={`added-${addedIdx}`}
                                                >
                                                  <td>
                                                    {`Other Cost: ${formatStringKey(
                                                      addedItem.Name,
                                                    )}`}{" "}
                                                    <span
                                                      className="blinking-text"
                                                      style={{
                                                        color: "green",
                                                        fontWeight: "bold",
                                                      }}
                                                    >
                                                      New
                                                    </span>
                                                  </td>

                                                  <td>N/A</td>

                                                  <td>
                                                    {addedItem.Amount || "N/A"}
                                                  </td>
                                                </tr>
                                              ),
                                            )}

                                          {fieldChange.removed &&
                                            fieldChange.removed.length > 0 &&
                                            fieldChange.removed.map(
                                              (removedItem, removedIdx) => (
                                                <tr
                                                  style={{
                                                    textDecoration:
                                                      "line-through",
                                                    color: "red",
                                                    marginRight: "5px",
                                                  }}
                                                  key={`removed-${removedIdx}`}
                                                >
                                                  <td
                                                    style={{ color: "red" }}
                                                  >
                                                    {`Other Cost: ${formatStringKey(
                                                      removedItem.Name,
                                                    )}`}
                                                  </td>

                                                  <td
                                                    style={{ color: "red" }}
                                                  >
                                                    {removedItem.Amount || "N/A"}
                                                  </td>

                                                  <td
                                                    style={{ color: "red" }}
                                                  >
                                                    N/A
                                                  </td>
                                                </tr>
                                              ),
                                            )}

                                          {fieldChange.modified &&
                                            fieldChange.modified.length > 0 &&
                                            fieldChange.modified.map(
                                              (
                                                modifiedItem,
                                                modifiedIdx,
                                              ) => (
                                                <tr
                                                  key={`modified-${modifiedIdx}`}
                                                >
                                                  <td>
                                                    {`Other Cost: ${formatStringKey(
                                                      modifiedItem.Name,
                                                    )}`}
                                                  </td>

                                                  <td>
                                                    {Number.isFinite(
                                                      modifiedItem.old_amount,
                                                    )
                                                      ? modifiedItem.old_amount
                                                      : "N/A"}
                                                  </td>

                                                  <td>
                                                    {Number.isFinite(
                                                      modifiedItem.new_amount,
                                                    )
                                                      ? modifiedItem.new_amount
                                                      : "N/A"}
                                                  </td>
                                                </tr>
                                              ),
                                            )}
                                        </React.Fragment>
                                      );
                                    }

                                    return (
                                      <tr key={`${idx}-${idx2}`}>
                                        <td>{formatStringKey(key)}</td>
                                        <td>{fieldChange.old || "N/A"}</td>
                                        <td>{fieldChange.new || "N/A"}</td>
                                      </tr>
                                    );
                                  },
                                );
                              })}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            ))
          ) : (
            <div className="data_not_available text-center pb-4">
              <Lottie animationData={notfoundData} />
              <p>No Vendor history available For this Quote.</p>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default SKU_Vendor_POPUP;
